import { render, staticRenderFns } from "./RepresentativeFormModal.vue?vue&type=template&id=8afdf98c&"
import script from "./RepresentativeFormModal.vue?vue&type=script&lang=js&"
export * from "./RepresentativeFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports